import { IDemoFlow, performed, proposal, step } from './types';

// The tech doc's Example 4 ("Create audience with segment at-risk users") and Figma A1-A6: the card
// creates it, or Edit in builder opens the audience builder in CREATE mode with the prefill. The
// criteria use the audience form's own shape: the doc's sample prefill is not well-formed.

// The doc's sample prefill, de-duplicated: its JSON repeats the second criterion.
const PREFILL = {
  name: 'Risk users',
  filters: {
    custom_attributes: [
      {
        type: 'custom_attributes',
        criteria: [
          {
            type: 'string',
            attribute: 'perx_internal_seg_lifecycle',
            operator: 'eq',
            selected_values: 'at_risk'
          },
          {
            type: 'string',
            attribute: 'perx_internal_seg_clv_predicted',
            operator: 'eq',
            selected_values: 'high'
          }
        ]
      }
    ]
  }
};

export const AUDIENCE_FLOWS: IDemoFlow[] = [
  {
    id: 'audience',
    prompt: 'Create audience with segment at-risk users',
    reply: now => ({
      outcome: 'action_proposed',
      answer: 'Here is the audience I will create:',
      action: proposal(
        step(
          'create_audience',
          'Create audience',
          { entity: 'audience', name: 'Risk users', subtype: null },
          { segment: 'At-risk users' }
        ),
        now,
        {
          buttons: [
            { id: 'confirm', label: 'Create audience' },
            { id: 'open_builder', label: 'Edit in builder' }
          ],
          builder: { form: 'audience_create', prefill: PREFILL }
        }
      )
    }),
    confirm: action => ({
      outcome: 'action_performed',
      answer: 'Created the audience Risk users (Audience ID: 312).',
      action: performed(action, { id: 312, state: 'active' })
    })
  }
];
